import { atom } from 'jotai';

export type RightSidebarContentId = 'notifications';

export const activeRightSidebarAtom = atom<RightSidebarContentId | null>(null);
